import { Field } from 'formik'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { JobWorkExperience } from '../../../types'
import styles from './index.module.scss'

type Props = {
  shouldShowUnselectedOption?: boolean
}

export const WorkExperienceField: FC<Props> = ({ shouldShowUnselectedOption = false }) => {
  const { t } = useTranslation(['jobs'])

  return (
    <div className={styles.container}>
      <Field as='select' name='workExperience'>
        {shouldShowUnselectedOption && <option value=''>---</option>}
        <option value={JobWorkExperience.NOT_REQUIRED}>{t(JobWorkExperience.NOT_REQUIRED)}</option>
        <option value={JobWorkExperience.ZERO_YEAR_OR_MORE}>{t(JobWorkExperience.ZERO_YEAR_OR_MORE)}</option>
        <option value={JobWorkExperience.ONE_YEAR_OR_MORE}>{t(JobWorkExperience.ONE_YEAR_OR_MORE)}</option>
        <option value={JobWorkExperience.TWO_YEARS_OR_MORE}>{t(JobWorkExperience.TWO_YEARS_OR_MORE)}</option>
        <option value={JobWorkExperience.THREE_YEARS_OR_MORE}>{t(JobWorkExperience.THREE_YEARS_OR_MORE)}</option>
        <option value={JobWorkExperience.FOUR_YEARS_OR_MORE}>{t(JobWorkExperience.FOUR_YEARS_OR_MORE)}</option>
        <option value={JobWorkExperience.FIVE_YEARS_OR_MORE}>{t(JobWorkExperience.FIVE_YEARS_OR_MORE)}</option>
        <option value={JobWorkExperience.SIX_YEARS_OR_MORE}>{t(JobWorkExperience.SIX_YEARS_OR_MORE)}</option>
        <option value={JobWorkExperience.SEVEN_YEARS_OR_MORE}>{t(JobWorkExperience.SEVEN_YEARS_OR_MORE)}</option>
        <option value={JobWorkExperience.EIGHT_YEARS_OR_MORE}>{t(JobWorkExperience.EIGHT_YEARS_OR_MORE)}</option>
        <option value={JobWorkExperience.NINE_YEARS_OR_MORE}>{t(JobWorkExperience.NINE_YEARS_OR_MORE)}</option>
        <option value={JobWorkExperience.TEN_YEARS_OR_MORE}>{t(JobWorkExperience.TEN_YEARS_OR_MORE)}</option>
      </Field>
    </div>
  )
}
